export const createDropInObject = (
  billingType,
  amount,
  currencyCode,
  entityName,
  client_token,
  merchant_id,
  google_pay_merchant_id,
) => {
  if (billingType == "recurring") {
    return {
      authorization: client_token,
      container: document.getElementById("dropin-container"),
    };
  }

  return {
    authorization: client_token,
    venmo: true,
    paypal: {
      flow: "checkout",
      amount: amount,
      currency: currencyCode,
    },
    applePay: {
      displayName: entityName,
      paymentRequest: {
        total: {
          label: entityName,
          amount: amount,
        },
      },
    },
    googlePay: {
      merchantId: google_pay_merchant_id,
      transactionInfo: {
        totalPriceStatus: "FINAL",
        currencyCode: currencyCode,
        totalPrice: amount,
      },
    },
    container: document.getElementById("dropin-container"),
  };
};
